import API_URL from "../config";
import axios from "axios";

import { getCookie } from "./../utils/cookies";

export const homeStatistiquesApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/eventStatistiques/homeStatistiquesCards/${id}/${iv}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getEventCategoryProgressionApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/eventStatistiques/oneEventDetailsCategory/${id}/${iv}/${eventID}`;
    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getEventProducerAndReseller = async (eventID) => {
  try {
        const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/eventStatistiques/oneEventDetailsProducerAndReseller/${id}/${iv}/${eventID}`;
    const res = await axios.get(url, option);

    return res.data;
  }
  catch (err) {
    throw err;
  }
}

export const getProducerEventCategoryProgressionApi = async (eventID, selectedRole, selectedTimeId = null) => {
  try {
        const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let url = `${API_URL}/api/V2/eventStatistiques/oneProducerEventDetailsCategory/${id}/${iv}/${eventID}?selectedRole=${selectedRole}`;
    if (selectedTimeId && selectedTimeId !== "#ALL") {
      url += `&selectedTimeId=${selectedTimeId}`;
    }
    const res = await axios.get(url, option);

    return res.data;
  }
  catch (err) {
    throw err;
  }
}

export const getEventCategoryProgressionCinemaApi = async (eventID, selectedHour) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/eventStatistiques/oneEventDetailsCinemaCategory/${id}/${iv}/${eventID}?selectedTimeId=${selectedHour}`;
    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getEventCategoryFillRateApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/eventStatistiques/oneEventDetailsFillRateCategory/${id}/${iv}/${eventID}`;

    console.log("Fetching category fill rate with URL:", url);

    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    console.error("Error in getEventCategoryFillRateApi:", err);
    throw err;
  }
};

export const oneEventStatistiquesApi = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/eventStatistiques/oneEventDetails/${id}/${iv}/${eventID}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const oneEventStatistiquesCinemaApi = async (eventID, selectedHour) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/eventStatistiques/oneEventDetailsCinema/${id}/${iv}/${eventID}?selectedTimeId=${selectedHour}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const chartLineDataApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/eventStatistiques/dailyEventDetails/${id}/${iv}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};
